{{>TrajectoryStyleInfoPanelPositionsTpl}}
{{>TrajectoryStyleInfoPanelTrajectoryTpl}}
{{>TrajectoryStyleInfoPanelEstimationTpl}}
{{>TrajectoryStyleInfoPanelBreakrouteTpl}}
{{#unless udaServiceArgos}}
  {{>TrajectoryStyleInfoPanelMobileSymbolTpl}}
  {{>TrajectoryStyleInfoPanelMobileColorTpl}}
{{/unless}}
{{>MobileTrajectoryTpl}}
